package com.ragnorak.clanybackoffice.di

import com.clany.backoffice.data.local.BrowserTokenStorage
import com.clany.backoffice.data.local.TokenStorage
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn

@ContributesTo(AppScope::class)
actual interface PlatformModule {
    @Provides
    @SingleIn(AppScope::class)
    fun provideTokenStorage(impl: BrowserTokenStorage): TokenStorage = impl
}
